import dayjs from 'dayjs';
import { useQueryResourceRootList } from '../../resource-roots/queries/useQueryResourceRootList.js';
import { useMemo } from 'react';
import { SystemSubtypes } from '@fabric/woody-client';

const sortByName = (root1, root2) => {
  if (root1.type === root2.type) {
    return (root1.folder.name || "").localeCompare(root2.folder.name || "");
  }
  return root1.type === "SYSTEM" ? -1 : 1;
};
const sortByLastResourceAdded = (root1, root2) => {
  if (root1.type === root2.type) {
    return dayjs(root2.lastResourceAddedAt).isBefore(dayjs(root1.lastResourceAddedAt)) ? -1 : 1;
  }
  return root1.type === "SYSTEM" ? -1 : 1;
};
const useQueryResourceRootSpaceSystemList = (queryFilter, options, queryConfig) => {
  const rootQuery = useQueryResourceRootList(queryFilter, queryConfig);
  const spaceRoots = useMemo(() => {
    if (!rootQuery.roots) {
      return void 0;
    }
    const filteredRoots = rootQuery.roots.filter((resourceRoot) => {
      if (resourceRoot.type === "SPACE") {
        return true;
      }
      if (options?.includeInbox && resourceRoot.type === "SYSTEM" && resourceRoot.subtype === SystemSubtypes.INBOX) {
        return true;
      }
      if (options?.includeSystem && resourceRoot.type === "SYSTEM") {
        return true;
      }
      if (options?.includeWriteableMirrorRoots && resourceRoot.type === "INTEGRATION" && !resourceRoot.folder.isReadonly) {
        return true;
      }
      return false;
    });
    return filteredRoots.sort(options?.sortFn || sortByName);
  }, [
    rootQuery.roots,
    options
  ]);
  return {
    ...rootQuery,
    /**
    * ordered alphabetically by name
    * type 'system' is always on top
    */
    spaceRoots
  };
};

export { sortByLastResourceAdded, sortByName, useQueryResourceRootSpaceSystemList };
//# sourceMappingURL=useQueryResourceRootSpaceSystemList.js.map
